import { RatingConfig } from "constants/ratings";
import "firebase/firestore";
import { useFirestore, useUser } from "reactfire";

const NAME = "CONFIG";

const isServerSide = () => {
  return typeof window === "undefined";
};

const useConfigStorage = () => {
  const user = useUser();
  const store = useFirestore();

  const setConfig = async (value: RatingConfig) => {
    if (user && user.data?.emailVerified) {
      await store.collection("config").doc(user.data?.uid).set({ value });

      return;
    }

    if (isServerSide()) {
      return;
    }

    localStorage.setItem(NAME, JSON.stringify(value));
  };

  const getConfig = async (): Promise<RatingConfig> => {
    if (user && user.data?.emailVerified) {
      const results = await store.collection("config").doc(user.data?.uid).get();

      if (!results.exists) {
        return {};
      }

      const data = results.data();

      return data.value;
    }

    if (isServerSide()) {
      return {};
    }

    const config = localStorage.getItem(NAME);

    if (!config) {
      return {};
    }

    return JSON.parse(config);
  };

  return { getConfig, setConfig };
};

export default useConfigStorage;
